import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Why Choose WordPress For Your <span>Business Website?</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              With a user-friendly interface and robust features, WordPress
              helps you build a dynamic digital platform for your business
              goals. Here’s why you should choose custom WordPress development
              services for your business website:
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Customization</h6>
                <p>
                  With a myriad of themes and plugins, WordPress offers
                  exceptional flexibility to craft a distinctive website
                  reflecting your brand accurately.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>User-Friendly Interface</h6>
                <p>
                  WordPress provides a business website with an intuitive,
                  user-friendly interface, ensuring effortless navigation and
                  interaction for optimal user experience.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>SEO-Friendly Platform</h6>
                <p>
                  WordPress is an SEO-friendly platform that ensures higher
                  visibility and rankings, optimizing your business website for
                  success.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Scalability</h6>
                <p>
                  Scaling your business is effortless with WordPress, ensuring
                  your website adapts and grows smoothly with increasing
                  demands.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Cost-Efficiency</h6>
                <p>
                  Choose WordPress for cost-efficient solutions, minimizing
                  expenses while maximizing the effectiveness of your business
                  website.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Mobile Responsiveness</h6>
                <p>
                  Select WordPress for superior mobile responsiveness, ensuring
                  your business website smoothly adapts for an excellent user
                  experience.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
